import React from 'react'

import SectionWrapper from '../SectionWrapper'

const AdsWrapper = ({ children }) => {
  return <SectionWrapper title={'Highest performing ads'}>{children}</SectionWrapper>
}

export default AdsWrapper
